/**
 * Registry for the store "welcome message" styles.
 *
 *   'classic'  -> the original static title/description modal
 *   <preset id> -> one of the 50 generated Lottie character animations
 *                  (see scripts/genWelcomeLottie.js + assets/welcome-lottie/)
 *
 * The Lottie JSON is loaded lazily so the 50 animations are never all
 * shipped on the storefront critical path.
 */
import manifest from '../assets/welcome-lottie/manifest.json';

export const CLASSIC_STYLE = 'classic';

/** Ordered list of animated presets: { id, name, character, entrance, decoration } */
export const WELCOME_PRESETS = manifest;

const PRESET_IDS = new Set(manifest.map((p) => p.id));

export const isAnimatedStyle = (style) =>
  !!style && style !== CLASSIC_STYLE && PRESET_IDS.has(style);

/** Normalize any persisted value to a known style id. */
export const resolveWelcomeStyle = (style) =>
  isAnimatedStyle(style) ? style : CLASSIC_STYLE;

/** Lazily import a preset's Lottie animation data. Returns a Promise<object>. */
export const loadWelcomeLottie = (id) =>
  import(
    /* webpackChunkName: "welcome-lottie" */ `../assets/welcome-lottie/${id}.json`
  ).then((m) => m.default || m);
